import React from "react";
import img1 from "../../images/eiffel-tower.jpg";
import img2 from "../../images/image.jpg";
const About = () => {
  return (
    <div className="card mb-3 container mt-5 m-l">
      <div className="row g-0">
        <h1 className="mt-5">About Us</h1>
        <hr className="w-75 mx-auto" />
        <div className="col-md-4">
          <img src={img1} className="img-fluid mt-5 border rounded" alt="..." />
          <img src={img2} className="img-fluid mt-5 border rounded" alt="..." />
        </div>
        <div className="col-md-8">
          <div className="card-body">
            <p>
              <h2>How Tourism Tiger started</h2>
              <p>
                Prior to starting Tourism Tiger, I worked in the SEO and social
                media sectors of tourism marketing, first for Australia’s
                largest SEO agency and then as an independent consultant. No
                matter the client, the story always followed the same lines:
                tour operators had a website that was several years old and
                making changes was difficult, impossible, or far too expensive.
                That wasn’t even the worst of it: all of these sites were
                gradually falling out of date, with no way to stop it! New
                technologies would come out, but which new feature made it
                worthwhile building a whole new website for? Something finally
                clicked… Why should a tourism website need a total rebuild every
                time a new change comes along? Why would a web designer wait for
                a client to request certain updates rather than anticipating
                that need? Why don’t tour & travel web design agencies have
                support teams dedicated to making all those necessary little
                changes? What happens to a client’s existing website when a web
                designer learns a new trick to make websites more effective? And
                so, Tourism Tiger was born. My wife Rebeca and I hit the ground
                running in January 2015 with a mission to build great websites
                for tour and activity operators that are effective from day 1
                and STAY effective in the years that follow. Rebeca’s design
                skills and my expertise in tourism marketing and SEO proved the
                perfect combination to get Tourism Tiger off the ground. In
                January of 2018 – almost 3 years to the day since Tourism Tiger
                sold its first website – we made a decision. The company was
                growing so quickly that we wanted to make sure we had a team in
                place to help take it to the next level. Rebeca and I were
                moving back to Australia and now was the time to hand over the
                reins. We had to make sure we were leaving the company in the
                hands of people who truly understand Tourism Tiger and shared
                our vision for the future and we found that in Russel and Simon.
                Those two – along with their fantastic (and ever expanding) team
                – have helped to build on what Rebeca and I set out to do in
                those early days. Crucially, our goal has remained the same – to
                help your tours or activities business thrive. We know that
                people book your tours from all over the world. We know your
                website is the face of your business. We aim to put your best
                foot forward, emphasizing the value of your tours and
                experiences, highlighting what sets your company apart, and
                presenting it all in a clear, appealing, and user-friendly way.
                Let us continue to focus on the technical stuff so that you can
                focus on giving your customers an unforgettable experience.
              </p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
